module.exports = __webpack_public_path__ + "img/sweden-other-heart-diseases-female.131fb3de.png";